import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { actionsHandlers, stateFactories } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialSingleFeatureStateFactory();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const inviteUserToRoleReducer = createReducer<State, Actions>(initialState, {
  [actions.sendInviteUserToRole.request.type]: actionsHandlers.handleSingleFeatureRequest,
  [actions.sendInviteUserToRole.success.type]: actionsHandlers.handleSingleFeatureSuccess,
  [actions.sendInviteUserToRole.failure.type]: actionsHandlers.handleSingleFeatureFailure,
  [actions.sendInviteUserToRole.reset.type]: actionsHandlers.handleSingleFeatureReset,
});

export default inviteUserToRoleReducer;
